import { render } from "./ViewLiquidationApproval.vue?vue&type=template&id=2793d586"
import script from "./ViewLiquidationApproval.vue?vue&type=script&lang=js"
export * from "./ViewLiquidationApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__